<template>
  <div class="person-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">{{ termPlural }}</span>
          </b-col>
<!--          <b-col cols="12" md="6">-->
<!--            <b-row class="d-flex align-items-center justify-content-end" >-->
<!--              <b-col cols="auto" v-if="canAdd">-->
<!--                <router-link tag="a" class="btn btn-primary btn-sm" :to="'/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar {{ termSingular }}</router-link>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Data do atendimento</label>
              <date-range-picker
                class="w-100"
                ref="picker"
                :localeData="dateRangePickerPtBrLocale"
                :timePicker="false"
                :timePicker24Hour="false"
                :showDropdowns="true"
                :ranges="false"
                :showWeekNumbers="false"
                :opens="'right'"
                v-model="attendanceGuideFilterForm.dateTime">
                <div slot="input" slot-scope="picker" class="">
                  <div class="vue-daterange-picker__clear" v-if="picker.startDate != null" @mousedown.prevent.stop="attendanceGuideFilterForm.dateTime.startDate = null; attendanceGuideFilterForm.dateTime.endDate = null;"></div>
                  {{ picker.startDate ? (moment(picker.startDate).format('DD/MM/YYYY') + ' - ' + moment(picker.endDate).format('DD/MM/YYYY'))  : '' }}
                </div>
              </date-range-picker>
            </b-col>
            <b-col>
              <label class="cj-label">Paciente</label>
              <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="attendanceGuideFilterForm.patient" :options="people" track-by="name" label="name" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="attendanceGuideFilterForm.patient != null" @mousedown.prevent.stop="attendanceGuideFilterForm.patient = null"></div>
                </template>
                <template slot="noOptions">
                  <div>
                    Digite para pesquisar seus pacientes...
                  </div>
                </template>
                <template slot="noResult" v-if="!isLoadingPeople">
                  <div>
                    Nenhum paciente encontrado...
                  </div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Profissional</label>
              <multiselect v-model="attendanceGuideFilterForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="attendanceGuideFilterForm.professional != null" @mousedown.prevent.stop="attendanceGuideFilterForm.professional = null"></div>
                </template>
              </multiselect>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label class="cj-label">Número da guia</label>
              <b-form-input type="text" v-model="attendanceGuideFilterForm.internal_id"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label">Convênio</label>
              <multiselect v-model="attendanceGuideFilterForm.healthPlan" :options="healthPlans" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="attendanceGuideFilterForm.healthPlan != null" @mousedown.prevent.stop="attendanceGuideFilterForm.healthPlan = null"></div>
                </template>
              </multiselect>
            </b-col>
<!--            <b-col>-->
<!--              <label class="cj-label">Categoria</label>-->
<!--              <multiselect v-model="attendanceGuideFilterForm.category" :options="categories" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">-->
<!--                <template slot="clear">-->
<!--                  <div class="multiselect__clear" v-if="attendanceGuideFilterForm.category != null" @mousedown.prevent.stop="attendanceGuideFilterForm.category = null"></div>-->
<!--                </template>-->
<!--              </multiselect>-->
<!--            </b-col>-->
            <b-col>
              <label class="cj-label">Status</label>
              <multiselect v-model="attendanceGuideFilterForm.status" :options="statusOptions" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false"></multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getAttendanceGuides()"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <b-row class="d-flex align-items-center">
                  <b-col cols="12" xl="6" class="mb-2 mb-xl-0">
                    <p class="title">Lista de {{ termPlural }}</p>
                  </b-col>
                  <b-col cols="12" xl="6" class="text-right">
                    <b-button size="sm" variant="primary" @click="exportItems()"><i class="far fa-download"></i> Exportar {{ termPlural }}</b-button>
                  </b-col>
                </b-row>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                    <tr>
                      <th>Número da guia</th>
                      <th>Data do atendimento</th>
                      <th>Convênio</th>
                      <th>Paciente</th>
                      <th>Profissional</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
<!--                    <tr class="line-add" v-if="canAdd">-->
<!--                      <td colspan="7" class="text-center">-->
<!--                        <router-link tag="a" class="btn btn-block btn-sm btn-add-new" :to="'/'+url+'/'+newTerm"><i class="far fa-plus-circle"></i> Adicionar nov{{ letter}} {{termSingular}}</router-link>-->
<!--                      </td>-->
<!--                    </tr>-->
                    <tr v-for="attendanceGuide in attendanceGuides" :key="attendanceGuide.id">
                      <td>{{ attendanceGuide.internal_id }}</td>
                      <td>{{ moment(attendanceGuide.start_datetime).format('DD/MM/YY HH:mm') }}</td>
                      <td>{{ attendanceGuide.health_plan }}</td>
                      <td>{{ attendanceGuide.patient.name }}</td>
                      <td>{{ attendanceGuide.professional }}</td>
                      <td>{{ attendanceGuide.pending?'Aberta':'Fechada' }}</td>
                      <td>
                        <b-button size="sm" variant="primary" @click="showAttendanceGuideModal(attendanceGuide)" v-if="canSee" class="mr-1"><i :class="'far ' + (attendanceGuide.pending ? 'fa-pencil-alt' : 'fa-eye')"></i></b-button>
                        <b-button size="sm" variant="danger" @click="deleteAttendanceGuide(attendanceGuide)" v-if="canRemove && attendanceGuide.pending && attendanceGuide.items.filter(item => (item.attendance_guide_invoice_id != null)).length == 0"><i class="far fa-trash-alt"></i></b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="attendanceGuides.length == 0" class="text-center sub-title">Você ainda não possui nenhum{{ (letter != 'o')?letter:'' }} {{ termSingular }} cadastrad{{ letter }}.</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal id="attendance-guide-modal" class="attendance-guide-modal" size="xl" ignore-enforce-focus-selector=".swal2-input" :modalClass="'attendance-guide-modal'" @hidden="resetAttendanceGuideModal">
      <template slot="modal-header">
        <div class="w-100 d-flex justify-content-between">
          <div>
            Guia de Atendimento #{{ attendanceGuideForm.internal_id }}
          </div>
          <div v-if="attendanceGuideForm.id != null">
            <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/' + attendanceGuideForm.id + '/imprimir'"><i class="far fa-print"></i></router-link>
          </div>
        </div>
      </template>
      <template slot="default">
        <b-col>
          <validation-observer ref="attendanceGuideForm" v-slot="{ invalid }">
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Convênio</label>
                <validation-provider name="convênio" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="attendanceGuideForm.health_plan" :disabled="true" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Data do atendimento</label>
                <b-form-input type="text" v-model="attendanceGuideForm.start_datetime" :disabled="true" autocomplete="off"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <label class="cj-label">Paciente</label><br/>
                <router-link tag="span" :to="'/pacientes/'+attendanceGuideForm.patient_id" class="preview link">{{ attendanceGuideForm.name }}</router-link>
<!--                <b-form-input type="text" v-model="attendanceGuideForm.name" :disabled="true" autocomplete="off"></b-form-input>-->
              </b-col>
              <b-col>
                <label class="cj-label">Profissional</label><br/>
                <router-link tag="span" :to="'/profissionais/'+attendanceGuideForm.professional_id" class="preview link">{{ attendanceGuideForm.professional }}</router-link>
<!--                <b-form-input type="text" v-model="attendanceGuideForm.professional" :disabled="true" autocomplete="off"></b-form-input>-->
              </b-col>
              <b-col>
                <label class="cj-label">Forma de faturamento</label>
                <validation-provider name="forma de faturamento" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="attendanceGuideForm.bill_type" :options="billTypeOptions" track-by="name" label="name" :preselectFirst="true" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(attendanceGuideForm.invoices.length > 0)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
          <hr>
          <validation-observer v-if="attendanceGuideForm.pending && user != null && (attendanceGuideForm.invoices.length === 0 || (user.person.type !== 'SECRETARY' && attendanceGuideForm.bill_type.value === 'accomplished_procedures'))" ref="attendanceGuideItemForm" v-slot="{ invalid }">
            <b-col class="p-3 mb-3 background-color-whisper">
              <b-row v-if="attendanceGuideForm.is_dentist" class="mb-2">
                <b-col>
                  <label class="cj-label">Dente/Área</label>
                  <validation-provider name="dente/área" :rules="{ required: true }" v-slot="{ errors }">
                    <multiselect v-model="attendanceGuideForm.item.tooth" :options="teeth" :showLabels="false" :searchable="true" placeholder="Dente/Área" :class="{ 'error': errors.length > 0 }"></multiselect>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
                <b-col>
                  <label class="cj-label">Face(s)</label>
<!--                  <validation-provider name="face" :rules="{ required: (typeof attendanceGuideForm.item.tooth === 'number') || (attendanceGuideForm.item.tooth != null && !isNaN(attendanceGuideForm.item.tooth)) }" v-slot="{ errors }">-->
                  <validation-provider name="face(s)" :rules="{ required: false }" v-slot="{ errors }">
                    <multiselect v-model="attendanceGuideForm.item.faces" :options="faces" :showLabels="false" :searchable="true" :multiple="true" placeholder="Face(s)" :class="{ 'error': errors.length > 0 }"></multiselect>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row class="mb-3">
                <b-col cols="12" md="6">
                  <label class="cj-label">Procedimento</label>
                  <validation-provider name="procedimento" :rules="{ required: true }" v-slot="{ errors }">
                    <multiselect ref="multiselectProcedure" :preserveSearch="true" v-model="attendanceGuideForm.item.procedure" :options="attendanceGuideProcedures" track-by="name" label="name" :loading="isLoadingAttendanceGuideProcedures" :internal-search="false" :options-limit="20" :limit="5" :max-height="200" @search-change="findAttendanceGuideProcedures" :showLabels="false" placeholder="Selecione um procedimento" :class="{ 'error': errors.length > 0 }">
                      <template slot="noOptions">
                        <div>
                          Digite para pesquisar procedimentos...
                        </div>
                      </template>
                      <template slot="noResult" v-if="!isLoadingAttendanceGuideProcedures">
                        <div>
                          Nenhum procedimento encontrado...
                        </div>
                      </template>
                    </multiselect>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
                <b-col>
                  <label class="cj-label">Quantidade</label>
                  <validation-provider name="quantidade" :rules="{ required: true }" v-slot="{ errors }">
                    <b-form-input v-model="attendanceGuideForm.item.amount" type="number" min="1" step="1" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
                <b-col>
                  <label class="cj-label">Valor</label>
                  <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                    <money v-model="attendanceGuideForm.item.value" class="form-control" :class="{ 'error': errors.length > 0 }"></money>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row class="mb-2 justify-content-end">
                <b-col cols="auto">
                  <b-button variant="success" @click="addItemToAttendanceGuide">Adicionar</b-button>
                </b-col>
              </b-row>
            </b-col>
          </validation-observer>

          <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
            <thead>
            <tr>
              <th v-if="attendanceGuideForm.is_dentist">Dente/Área</th>
              <th v-if="attendanceGuideForm.is_dentist">Face(s)</th>
              <th>Procedimento</th>
              <th>Quantidade</th>
              <th>Valor</th>
              <th class="text-center">Realizado?</th>
              <th class="text-center">Faturado?</th>
              <th class="text-center"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) of attendanceGuideForm.items" :key="index">
              <td v-if="attendanceGuideForm.is_dentist">{{ item.tooth != null ? item.tooth : '-' }}</td>
              <td v-if="attendanceGuideForm.is_dentist">{{ item.faces != null ? item.faces : '-' }}</td>
              <td>{{ item.procedure.name }}</td>
              <td>{{ item.amount }}</td>
              <td>R$ {{ formatPrice(item.value) }}</td>
              <td class="text-center">
                  <div v-if="!attendanceGuideForm.pending || (attendanceGuideForm.bill_type.value === 'accomplished_procedures' && item.attendance_guide_invoice_id != null) || (user != null && (user.person.type === 'SECRETARY' && attendanceGuideForm.bill_type.value === 'accomplished_procedures' && attendanceGuideForm.invoices.length > 0))" class="pretty p-switch p-fill">
                    {{item.accomplished ? 'Sim' : 'Não'}}
                  </div>
                  <div v-else class="pretty p-switch p-fill">
                    <input type="checkbox" v-model="item.accomplished" />
                    <div class="state p-success">
                        <label></label>
                    </div>
                </div>
              </td>
              <td class="text-center">
                {{item.attendance_guide_invoice_id != null ? 'Sim' : 'Não'}}
              </td>
              <td class="text-center">
                <b-button v-if="item.attendance_guide_invoice_id == null && user != null && (user.person.type !== 'SECRETARY' || attendanceGuideForm.invoices.length === 0)" size="sm" variant="danger" @click="removeItemFromAttendanceGuide(index)"><i class="far fa-trash-alt"></i></b-button>
              </td>
            </tr>
            <tr v-if="attendanceGuideForm.items.length == 0">
              <td :colspan="(attendanceGuideForm.is_dentist ? 8 : 6)" class="text-center">
                Nenhum item adicionado à guia.
              </td>
            </tr>
            </tbody>
            <tfoot v-if="attendanceGuideForm.items.length > 0">
            <tr>
              <td v-if="attendanceGuideForm.is_dentist"></td>
              <td v-if="attendanceGuideForm.is_dentist"></td>
              <td></td>
              <td class="text-right">Total:</td>
              <td>R$ {{ formatPrice(attendanceGuideForm.items.reduce((total, item) => total + item.value, 0)) }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            </tfoot>
          </table>

          <div v-if="attendanceGuideForm.invoices.length > 0">
            <label class="text1">Faturas</label>
          </div>
          <table v-if="attendanceGuideForm.invoices.length > 0" class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
            <thead>
            <tr>
              <th>Lançamento</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Baixa</th>
              <th class="text-center"></th>
            </tr>
            </thead>
            <tbody>
              <template v-for="(invoice, index) in attendanceGuideForm.invoices">
                <tr v-for="(transaction, transactionIndex) of invoice.transactions" :key="index + '-' + transactionIndex">
                  <td>{{ moment(transaction.registration_date).format('DD/MM/YYYY') }}</td>
                  <td>{{ transaction.charge_date != null ? moment(transaction.charge_date).format('DD/MM/YYYY') : '-' }}</td>
                  <td>R$ {{ formatPrice(transaction.value) }}</td>
                  <td>{{ !transaction.discharged?'Não ':'' }} Recebido</td>
                  <td>{{ transaction.discharge_date != null ? moment(transaction.discharge_date).format('DD/MM/YYYY') : '' }}</td>
                  <td class="text-center">
                    <router-link v-if="transaction != null" tag="button" class="btn btn-primary btn-sm" :to="'/financeiro/contas-a-receber/'+transaction.id"><i class="far fa-eye mr-1"></i> Ver fatura</router-link>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot v-if="attendanceGuideForm.items.length > 0">
              <tr>
                <td></td>
                <td class="text-right">Total:</td>
                <td>R$ {{ formatPrice(attendanceGuideForm.invoices.reduce((total, invoice) => total + invoice.transactions.reduce((totalTransaction, transaction) => totalTransaction + transaction.value, 0), 0)) }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td class="text-right">Comissão:</td>
                <td>R$ {{ formatPrice(attendanceGuideForm.professional_commission_percentage * attendanceGuideForm.invoices.reduce((total, invoice) => total + invoice.transactions.reduce((totalTransaction, transaction) => totalTransaction + transaction.value, 0), 0) / 100.0) }}</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </b-col>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('attendance-guide-modal')">Fechar</b-button>
        <b-button v-if="canEdit && attendanceGuideForm.pending && user != null && (user.person.type !== 'SECRETARY' || (attendanceGuideForm.bill_type.value === 'accomplished_procedures' && attendanceGuideForm.invoices.length === 0))" size="sm" variant="success" @click="saveAttendanceGuide(false)">Salvar</b-button>
        <b-button v-if="helpers.planHasPermission('financial') && canEdit && attendanceGuideForm.pending && attendanceGuideForm.bill_type != null && (attendanceGuideForm.bill_type.value === 'accomplished_procedures' || attendanceGuideForm.invoices.length === 0)" size="sm" variant="primary" @click="billAttendanceGuide()">Faturar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'guia de atendimento',
        termPlural: 'guias de atendimento',
        url: 'guias-de-atendimento',
        letter: 'a',
        newTerm: 'cadastrar-conta-a-receber',
        dischargedTerm: 'recebido',
        module: 'attendance-guides',

        user: null,

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canPerformAction: true,

        attendanceGuideFilterForm: {
          dateTime: { startDate: this.moment().startOf('month'), endDate: this.moment().endOf('month') },
          patient: null,
          professional: null,
          internal_id: '',
          healthPlan: null,
          status: { value: '', name: 'Indiferente' },
          billed: { value: null, name: 'Indiferente' },
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        },

        // categories: [],
        professionals: [],
        healthPlans: [],

        statusOptions: [
          { value: '', name: 'Indiferente' },
          { value: 1, name: 'Aberta' },
          { value: 0, name: 'Fechada' }
        ],

        people: [],
        isLoadingPeople: false,
        findPeopleTimer: null,

        attendanceGuides: [],

        billTypeOptions: [
          { value: 'accomplished_procedures', name: 'Por procedimento realizado' },
          { value: 'full_guide', name: 'Guia completa' }
        ],

        attendanceGuideForm: {
          id: null,
          appointment_id: null,
          start_datetime: '',
          internal_id: '',
          patient_id: '',
          name: '',
          professional_id: '',
          professional: '',
          professional_commission_percentage: 0,
          is_dentist: false,
          health_plan: '',
          bill_type: '',
          authorization_code: '',
          pending: true,
          items: [],
          invoices: [],
          item: {
            tooth: null,
            faces: null,
            procedure: null,
            amount: 1,
            value: 0,
            accomplished: false
          }
        },
        attendanceGuideProcedures: [],
        isLoadingAttendanceGuideProcedures: false,
        findAttendanceGuideProceduresTimer: null,

        teeth: ['Boca toda', 'Arcada Superior', 'Arcada Inferior', 11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28, 31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52, 53, 54, 55, 61, 62, 63, 64, 65, 71, 72, 73, 74, 75, 81, 82, 83, 84, 85],
        faces: ['Vestibular', 'Palatina', 'Lingual', 'Mesial', 'Distal', 'Oclusal', 'Incisal'],

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }


      this.eventBus.$emit('IS_LOADING', true);

      document.addEventListener('focusin', function (e) {
        let closest = e.target.closest('.swal2-input');
        if (closest !== null && closest !== undefined) {
          e.stopImmediatePropagation();
        }
      });

      await this.api.getPeople({type: 'PROFESSIONAL', all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.professionals = [];
        res.data.forEach(professional => {
          let dentistSpecialty = professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          });
          this.professionals.push({
            value: professional.id,
            name: professional.name,
            is_dentist: dentistSpecialty !== undefined
          });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Professional', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os profissionais da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Professional', err.response);
      });

      await this.api.getHealthPlans({all: true}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.healthPlans = [];
        res.data.forEach(health_plan => {
          this.healthPlans.push({ value: health_plan.id, name: health_plan.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Health Plans', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os convênios da sua clínica! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Health Plans', err.response);
      });

      if(this.$route.query.internal_id) {
        this.attendanceGuideFilterForm.internal_id = this.$route.query.internal_id;
        this.attendanceGuideFilterForm.dateTime.startDate = null;
        this.attendanceGuideFilterForm.dateTime.endDate = null;
      }

      await this.getAttendanceGuides();
    },
    methods: {
      getAttendanceGuides() {
        let attendanceGuideFilterData = {
          start_date: this.attendanceGuideFilterForm.dateTime.startDate ? this.moment(this.attendanceGuideFilterForm.dateTime.startDate).format('YYYY-MM-DD') : null,
          end_date: this.attendanceGuideFilterForm.dateTime.endDate ? this.moment(this.attendanceGuideFilterForm.dateTime.endDate).format('YYYY-MM-DD') : null,
          patient: (this.attendanceGuideFilterForm.patient != null)?this.attendanceGuideFilterForm.patient.value:null,
          professional: (this.attendanceGuideFilterForm.professional != null)?this.attendanceGuideFilterForm.professional.value:null,
          health_plan: (this.attendanceGuideFilterForm.healthPlan != null)?this.attendanceGuideFilterForm.healthPlan.value:null,
          internal_id: this.attendanceGuideFilterForm.internal_id != null && this.attendanceGuideFilterForm.internal_id != '' ? this.attendanceGuideFilterForm.internal_id : null,
          status: (this.attendanceGuideFilterForm.status != null && this.attendanceGuideFilterForm.status.value != '')?this.attendanceGuideFilterForm.status.value:null
        };
        if(attendanceGuideFilterData.start_date == null && attendanceGuideFilterData.patient == null && attendanceGuideFilterData.professional == null
            && attendanceGuideFilterData.health_plan == null && attendanceGuideFilterData.internal_id == null && attendanceGuideFilterData.status == null) {
          this.$swal('Ops...', 'Por favor, selecione pelo menos um filtro para a busca.', 'warning');
          return;
        }
        this.eventBus.$emit('IS_LOADING', true);

        this.api.getAttendanceGuides(attendanceGuideFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.attendanceGuides = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Attendance Guides', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar '+this.letter+'s '+this.termSingular+' da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Attendance Guides', err.response);
        });
      },

      limitPeople(qty) {
        return 'e '+qty+' outros pacientes';
      },

      findPeople(query) {
        this.people = [];
        if(query.length >= 3 && !this.isLoadingPeople) {
          if(this.findPeopleTimer !== null) {
            clearTimeout(this.findPeopleTimer);
          }
          this.findPeopleTimer = setTimeout(() => {
            this.isLoadingPeople = true;
            this.api.getPeople({ type: 'PATIENT', name: query }).then(res => {
              if(this.leavingPage) {
                return;
              }
              this.isLoadingPeople = false;

              res.data.data.forEach(patient => {
                this.people.push({
                  value: patient.id,
                  name: patient.name
                });
              });
            }).catch(err => {
              if(this.leavingPage) {
                return;
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Patients', err.response);
            });
          }, 300);
        }
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      resetAttendanceGuideModal() {
        this.attendanceGuideForm = {
          id: null,
          appointment_id: null,
          start_datetime: '',
          internal_id: '',
          patient_id: '',
          name: '',
          professional_id: '',
          professional: '',
          is_dentist: false,
          health_plan: '',
          bill_type: '',
          pending: true,
          items: [],
          invoices: [],
          invoiceStatements: [],
          item: {
            tooth: null,
            faces: null,
            procedure: null,
            amount: 1,
            value: 0,
            accomplished: false
          }
        };
      },

      findAttendanceGuideProcedures(query) {
        this.attendanceGuideProcedures = [];
        if(query.length >= 3 && !this.isLoadingAttendanceGuideProcedures) {
          if(this.findAttendanceGuideProceduresTimer !== null) {
            clearTimeout(this.findAttendanceGuideProceduresTimer);
          }
          this.findAttendanceGuideProceduresTimer = setTimeout(() => {
            this.isLoadingAttendanceGuideProcedures = true;
            this.api.getProcedures({ term: query }).then(res => {
              if(this.leavingPage) {
                return;
              }
              this.isLoadingAttendanceGuideProcedures = false;

              this.attendanceGuideProcedures = res.data.data.map(procedure => {
                return { value: procedure.id, name: procedure.name, procedure_value: procedure.value, cnae: procedure.cnae };
              });
            }).catch(err => {
              if(this.leavingPage) {
                return;
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error AttendanceGuideProcedures', err.response);
            });
          }, 300);
        }
      },

      async addItemToAttendanceGuide() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.attendanceGuideItemForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let item = this.attendanceGuideForm.item;
        if(item.faces != null) {
          item.faces = item.faces.join(', ');
        }
        this.attendanceGuideForm.items.push(item);

        this.attendanceGuideForm.item = {
          tooth: null,
          faces: null,
          procedure: null,
          amount: 1,
          value: 0,
          accomplished: false
        };

        this.$refs.attendanceGuideItemForm.reset();
        this.canPerformAction = true;
      },

      async removeItemFromAttendanceGuide(index) {
        this.attendanceGuideForm.items.splice(index, 1);
      },

      async billAttendanceGuide() {
        if(!this.canPerformAction)
          return false;

        const isValid = await this.$refs.attendanceGuideForm.validate();
        if(!isValid) {
          return false;
        }
        if(this.attendanceGuideForm.items.length === 0) {
          this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
          return false;
        }
        if(this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
          this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
          return false;
        }

        if(this.user.person.client.enable_mandic_nf) {
          let items = this.attendanceGuideForm.items,
            cnaes = [];
          if(this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
            items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
          }
          items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
            return false;
          }
        }

        this.attendanceGuideForm.authorization_code = '';

        if(this.attendanceGuideForm.health_plan !== 'Particular') {
          let { value: authorizationCode } = await this.$swal({
            title: 'N° de Autorização de Guia de Atendimento',
            text: 'Informe o número de autorização para faturamento ' + (this.attendanceGuideForm.id == null ? 'desta guia' : ('da guia ' + this.attendanceGuideForm.internal_id)),
            input: 'text',
            inputLabel: 'Número de autorização',
            inputAttributes: {
              maxlength: 100,
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
              if (!value) {
                return 'Você tem que preencher o número de autorização!'
              }
            }
          });
          if(authorizationCode) {
            this.attendanceGuideForm.authorization_code = authorizationCode;
            this.saveAttendanceGuide(true);
          }
        }
        else {
          this.saveAttendanceGuide(true);
        }
      },

      async saveAttendanceGuide(bill) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.attendanceGuideForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        if(this.attendanceGuideForm.items.length === 0) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
          return false;
        }
        if(bill && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
          return false;
        }

        if(bill && this.user.person.client.enable_mandic_nf) {
          let items = this.attendanceGuideForm.items,
              cnaes = [];
          if(this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
            items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
          }
          items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
            return false;
          }
        }

        let attendanceGuideData = {
          bill_type: this.attendanceGuideForm.bill_type.value,
          bill: bill,
          authorization_code: bill ? this.attendanceGuideForm.authorization_code : null,
          items: this.attendanceGuideForm.items.map(item => {
            return {
              id: item.id,
              procedure_id: item.procedure.value,
              tooth: item.tooth,
              faces: item.faces,
              amount: item.amount,
              value: item.value,
              accomplished: item.accomplished
            }
          })
        };

        this.eventBus.$emit('IS_LOADING', true);
        await this.api.updateAttendanceGuide(this.attendanceGuideForm.appointment_id, this.attendanceGuideForm.id, attendanceGuideData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          if (res.status == 201) {
            this.$bvModal.hide('attendance-guide-modal');
            if(bill) {
              let transactionId = res.data.id;
              this.$swal('Uhull \\o/', 'A guia de atendimento foi atualizada com sucesso! Agora finalize o cadastro da fatura.', 'success').then(() => {
                this.$router.push({path: '/financeiro/contas-a-receber/' + transactionId}).catch(() => {});
              });
            }
            else {
              this.getAttendanceGuides();
              this.$swal('Uhull \\o/', 'A guia de atendimento foi atualizada com sucesso!', 'success');
            }

          } else {
            this.$swal('Ops...', 'Ocorreu um erro ao atualizar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Update Attendance Guide', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos atualizar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Update Attendance Guide', err.response);
        });
      },

      deleteAttendanceGuide(attendanceGuide) {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir guia de atendimento',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deleteAttendanceGuide(attendanceGuide.appointment_id, attendanceGuide.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.getAttendanceGuides();

                this.$swal('Uhull \\o/', 'A guia de atendimento foi excluída com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir a guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Attendance Guide', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Attendance Guide', err.response);
            });
          }
        });
      },

      showAttendanceGuideModal(attendanceGuide) {
        if(!this.canPerformAction)
          return false;

        this.attendanceGuideForm.id = attendanceGuide.id;
        this.attendanceGuideForm.appointment_id = attendanceGuide.appointment_id;
        this.attendanceGuideForm.start_datetime = this.moment(attendanceGuide.start_datetime).format('DD/MM/YYYY HH:mm');
        this.attendanceGuideForm.internal_id = attendanceGuide.internal_id;
        this.attendanceGuideForm.patient_id = attendanceGuide.patient.id;
        this.attendanceGuideForm.name = attendanceGuide.patient.name;
        this.attendanceGuideForm.professional_id = attendanceGuide.professional_id;
        this.attendanceGuideForm.professional = attendanceGuide.professional;
        this.attendanceGuideForm.professional_commission_percentage = attendanceGuide.professional_commission_percentage != null ? attendanceGuide.professional_commission_percentage : 0;
        this.attendanceGuideForm.health_plan = attendanceGuide.health_plan;
        this.attendanceGuideForm.bill_type = this.billTypeOptions.find(billType => billType.value == attendanceGuide.bill_type);
        this.attendanceGuideForm.pending = attendanceGuide.pending;
        this.attendanceGuideForm.items = attendanceGuide.items;
        this.attendanceGuideForm.invoices = attendanceGuide.attendance_guide_invoices;
        this.attendanceGuideForm.invoices.forEach(invoice => {
          invoice.transactions = invoice.transactions.sort((a, b) => (a.charge_date > b.charge_date)?1:-1);
        });
        let professional = this.professionals.find(professional => professional.value == attendanceGuide.professional_id);
        this.attendanceGuideForm.is_dentist = professional.is_dentist;

        // this.attendanceGuideForm
        this.$bvModal.show('attendance-guide-modal');
        this.canPerformAction = true;
      },

      exportItems() {
        this.eventBus.$emit('IS_LOADING', true);
        let attendanceGuideFilterData = {
          start_date: this.attendanceGuideFilterForm.dateTime.startDate ? this.moment(this.attendanceGuideFilterForm.dateTime.startDate).format('YYYY-MM-DD') : null,
          end_date: this.attendanceGuideFilterForm.dateTime.endDate ? this.moment(this.attendanceGuideFilterForm.dateTime.endDate).format('YYYY-MM-DD') : null,
          patient: (this.attendanceGuideFilterForm.patient != null)?this.attendanceGuideFilterForm.patient.value:null,
          professional: (this.attendanceGuideFilterForm.professional != null)?this.attendanceGuideFilterForm.professional.value:null,
          health_plan: (this.attendanceGuideFilterForm.healthPlan != null)?this.attendanceGuideFilterForm.healthPlan.value:null,
          internal_id: this.attendanceGuideFilterForm.internal_id != null && this.attendanceGuideFilterForm.internal_id != '' ? this.attendanceGuideFilterForm.internal_id : null,
          status: (this.attendanceGuideFilterForm.status != null)?this.attendanceGuideFilterForm.status.value:null
        };
        if(attendanceGuideFilterData.start_date == null && attendanceGuideFilterData.patient == null && attendanceGuideFilterData.professional == null
            && attendanceGuideFilterData.health_plan == null && attendanceGuideFilterData.internal_id == null && attendanceGuideFilterData.status == null) {
          this.$swal('Ops...', 'Por favor, selecione pelo menos um filtro para a busca.', 'warning');
          return;
        }

        this.api.exportAttendanceGuidesData(attendanceGuideFilterData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          var type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              blob = new Blob([res.data], { type: type }),
              anchor = document.createElement('a');

          anchor.download = 'guias-de-atendimento.xlsx';
          anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
          anchor.dataset.downloadurl = [type, anchor.download, anchor.href].join(':');
          anchor.click();

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Export Attendance Guides', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos exportar as guias de atendimento da sua clínica! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Export Attendance Guides', err.response);
        });
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      if(this.findPeopleTimer !== null) {
        clearTimeout(this.findPeopleTimer);
      }
      if(this.findAttendanceGuideProceduresTimer !== null) {
        clearTimeout(this.findAttendanceGuideProceduresTimer);
      }
      next();
    }
  }
</script>

<style lang="scss">
  .person-list {
    padding: 20px 0;

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }
        }
      }
    }
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }

  .preview {
    color: $waikawaGray;

    &.link {
      cursor: pointer;

      &:hover {
        color: $curiousBlue;
        text-decoration: underline;
      }
    }
  }
</style>
